const cases = {
  casesPage: {
    header: {
      titlePrefix: "Real-World",
      titleHighlight: "Impact",
      subtitle:
        "Discover how I help organizations transform complex data into competitive advantages through innovative AI solutions and strategic guidance.",
    },
    card: {
      resultLabel: "Result",
      viewCase: "View Case",
    },
    cta: {
      titlePrefix: "Transform Your",
      titleHighlight1: "Data",
      titleMiddle: "into",
      titleHighlight2: "Value",
      subtitle:
        "Looking for similar results for your organization? Let's discuss how we can implement tailored AI solutions and data strategies that drive real business growth.",
      primaryButton: "Book a Strategy Call",
      secondaryButton: "Send a Message",
    },
  },
  caseDetail: {
    technologiesUsed: "Technologies Used",
    suggestedTitle: "You Might Also Be Interested In",
    viewCase: "View Case",
    footerCta: {
      titlePrefix: "Interested in a",
      titleHighlight: "Similar Solution?",
      subtitle: "Let's discuss how we can adapt this technology to your specific business needs and accelerate your AI roadmap.",
      primaryButton: "Book a Strategy Call",
      secondaryButton: "Send a Message",
    },
  },
};

export default cases;
